const NoteIcon = ({ fill = '#004949', width = '17', height = '16' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="list/sticky_note_2">
        <mask
          id="mask0_10403_397"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="17"
          height="16"
        >
          <rect
            id="Bounding box"
            x="0.369141"
            width="16"
            height="16"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_10403_397)">
          <path
            id="icon"
            d="M3.70247 12.6667H9.70247V9.33333H13.0358V3.33333H3.70247V12.6667ZM3.70247 14C3.33581 14 3.02192 13.8694 2.76081 13.6083C2.4997 13.3472 2.36914 13.0333 2.36914 12.6667V3.33333C2.36914 2.96667 2.4997 2.65278 2.76081 2.39167C3.02192 2.13056 3.33581 2 3.70247 2H13.0358C13.4025 2 13.7164 2.13056 13.9775 2.39167C14.2386 2.65278 14.3691 2.96667 14.3691 3.33333V10L10.3691 14H3.70247ZM5.03581 9.33333V8H8.36914V9.33333H5.03581ZM5.03581 6.66667V5.33333H11.7025V6.66667H5.03581Z"
            fill={fill}
          />
        </g>
      </g>
    </svg>
  )
}

export default NoteIcon
